module.exports = __webpack_public_path__ + "img/level_15_premium.6702555d.svg";